import type { GetStaticProps, NextPage } from 'next';
import PageService from 'services/PageService/PageService';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import Articles from 'blocks/travel-journal-articles/home';
import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';
import type { IGlobalLayout } from 'types/interfaces';
import type { TravelJournalArticlesType } from 'api/travel-journal/types';
import { TravelJournalCategoryType } from 'types/types';

type ArticlesProps = {
  globalLayoutProps: IGlobalLayout;
  articles: TravelJournalArticlesType[];
  categories: TravelJournalCategoryType[];
};

const TravelJournalHome: NextPage<ArticlesProps> = ({
  globalLayoutProps,
  articles,
  categories,
}) => {
  return (
    <GlobalLayout {...globalLayoutProps}>
      <Articles articles={articles} categories={categories} />
    </GlobalLayout>
  );
};

export default TravelJournalHome;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.TRAVEL_JOURNAL_ARTICLES,
  });

  const articles = await PageService.getTravelJournalArticlesPage();
  const categories = await PageService.getTravelJournalCategories();

  return {
    props: {
      ...genericPageProps,
      ...articles,
      ...categories,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
